import React, { useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import Notification from "rc-notification";
import axios from "axios";
// import { Modal } from '../../components/Modal';
import { ModalUsePortal } from "../../components/ModalUsePortal";
import { Button } from "../../components/Button";
import { Input } from "../../components/Input";
import { useTranslation } from "react-i18next";
import ReactLoading from "react-loading";
import "./styles.less";
import { tryAgl, tryAglAPI } from "../../utils/tryAgl";
import { isSem } from "../../utils";

export const ConsultModal = (props) => {
  const { visible, setVisible } = props;
  const { handleSubmit, register, errors, reset } = useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  // const phoneNumber = useMemo(
  //   () => (isSem ? "400-6197-031" : "176-0250-2507"),
  //   []
  // );

  const onSubmit = async (values) => {
    setLoading(true);
    let notification = null;
    Notification.newInstance(
      { style: { top: 65, left: "50%", transform: "translateX(-50%)" } },
      (n) => (notification = n)
    );
    try {
      const { data: res } = await axios.post("/api/contact-us", values);
      if (res.code === 200) {
        setVisible(false);
        setLoading(false);
        tryAgl();
        // tryAglAPI();
        notification.notice({
          content: (
            <span>
              <i className="icon authing-icon authing-wancheng ntf-success-icon"></i>
              {t("common.form.success-tip")}
            </span>
          ),
          duration: 5,
        });
        reset();
      }
    } finally {
      setVisible(false);
      setLoading(false);
    }
  };

  const onError = (errors, e) => {
    console.log(errors);
  };

  const form = () => {
    return (
      <div className="form">
        <div>
          <div className="form-title">{t("common.form.contact-title")}</div>
          <div className="form-subtitle">
            {t("common.form.contact-subtitle")}
          </div>
          <div
            className="form-close"
            onClick={() => {
              setVisible(false);
              setLoading(false);
            }}
          >
            <i className="icon authing-icon authing-guanbi"></i>
          </div>
          <form onSubmit={handleSubmit(onSubmit, onError)}>
            <div className="form-item">
              <div className="label required">
                {t("common.form.contact-name")}
              </div>
              <div className="input">
                <Input
                  error={errors.name}
                  placeholder={t("common.form.name-placeholder")}
                  name="name"
                  inputRef={register({
                    required: true,
                  })}
                />
              </div>
            </div>
            <div className="form-item">
              <div className="label required">
                {t("common.form.contact-way")}
              </div>
              <div className="input">
                <Input
                  name="phone"
                  error={errors.phone}
                  placeholder={t("common.form.phone-placeholder")}
                  inputRef={register({
                    required: true,
                  })}
                />
              </div>
            </div>
            <div className="form-item">
              <div className="label">{t("common.form.company")}</div>
              <div className="input">
                <Input
                  name="company"
                  error={errors.company}
                  inputRef={register()}
                />
              </div>
            </div>
            <div className="form-item">
              <div className="label">{t("common.form.position")}</div>
              <div className="input">
                <Input
                  name="position"
                  error={errors.position}
                  inputRef={register()}
                />
              </div>
            </div>

            <div className="form-item">
              <div className="label">{t("common.form.other")}</div>
              <div className="input">
                <Input
                  name="other"
                  error={errors.other}
                  inputRef={register()}
                />
              </div>
            </div>
            <div className="form-item">
              <Button
                type="submit"
                className="consult-submit"
                style={{ width: "100%" }}
                disabled={loading}
              >
                {loading ? (
                  <ReactLoading
                    type={"spin"}
                    height={20}
                    width={20}
                    delay={0}
                    className={"spin-loading"}
                  />
                ) : (
                  ""
                )}

                {t("common.form.submit")}
              </Button>
            </div>
          </form>
          <div className="form-bottom">
            <div className="text">{t("common.form.contact-tip")}</div>
            <div className="contact">
              <div className="img">
                <img
                  src={"//files.authing.co/authing-website/contact-recode.png"}
                  alt="authing contact recode"
                />
              </div>
              <div>
                <div className="phone">400-6197-031</div>
                <div className="email">sales@authing.cn</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <ModalUsePortal show={visible}>
      <div className="consult-modal">{form()}</div>
    </ModalUsePortal>
  );
};

// {/* <Modal {...{ visible, setVisible }}>{form()}</Modal> */}
